import React, { FC } from 'react';
import { ValuationMethodsDetailTable } from './components';
import { ValuationMethodsDetailProps } from './types';

const ValuationMethodsDetail: FC<ValuationMethodsDetailProps> = props => <ValuationMethodsDetailTable {...props} />;

export default ValuationMethodsDetail;
